export const priceToNumber = (value: string): number | any => {
  if (!value) return value
  let price = value
  price = price.replaceAll('R$', '')
  price = price.replaceAll('.', '')
  price = price.replaceAll(',', '.')
  return Number(price)
}

export const numberToPrice = (value: number, withSymbol = false): string => {
  const response = value.toLocaleString(
    'pt-BR',
    {
      style: 'currency',
      currency: 'BRL',
      currencyDisplay: (withSymbol ? 'symbol' : 'none'),
    },
  )

  return response
}

export const getCurrencyFormat = (currencyCode: string, display: string) => (
  {
    style: 'currency',
    currency: currencyCode,
    currencyDisplay: display,
  }
)

export const formatCurrency = (value: number, format: any, lang: any) => {
  const stripSymbols = (format.currencyDisplay === 'none')
  const localFormat = stripSymbols ? { ...format, currencyDisplay: 'code' } : format
  let result = Intl.NumberFormat(lang, localFormat).format(value)
  if (stripSymbols) {
    result = result.replace(/[a-z]{3}/i, '').trim()
  }
  return result
}
